import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const SiteContext = createContext({ settings: {}, products: [], partners: [], loading: true });

export function SiteProvider({ children }) {
  const [state, setState] = useState({ settings: {}, products: [], partners: [], loading: true });

  useEffect(() => {
    Promise.all([
      api.get("/settings").then((r) => r.data).catch(() => ({})),
      api.get("/products").then((r) => r.data).catch(() => []),
      api.get("/partners").then((r) => r.data).catch(() => []),
    ]).then(([settings, products, partners]) => {
      setState({ settings, products, partners, loading: false });
    });
  }, []);

  return <SiteContext.Provider value={state}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
